import createTaxonomyLink from './createTaxonomyLink';
import createTaxonomyListFromQuery from './createTaxonomyListFromQuery';

export default query => {
	const queryTaxonomyList = createTaxonomyListFromQuery(query);
	return createTaxonomyLink(queryTaxonomyList);
};